import * as React from "react"

import { cn } from "@/lib/utils"

const AUTOFILL_BLOCKERS = {
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  "data-lpignore": "true",
  "data-form-type": "other",
};

function useRandomName(prefix = "ta") {
  return React.useMemo(() => `${prefix}-${Math.random().toString(36).slice(2, 10)}`, []);
}

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  const randomName = useRandomName("ta");
  const merged = { ...AUTOFILL_BLOCKERS, ...props };
  if (merged.name === undefined) merged.name = randomName;
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...merged} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
